module.exports = __webpack_public_path__ + "img/cashback_768.829240c2.png";